import { useCallback, useEffect, useState } from 'react';

export function smoothScrollToTop(duration = 500) {
    const start = window.scrollY;
    const startTime = performance.now();

    function scroll() {
        const now = performance.now();
        const time = Math.min(1, (now - startTime) / duration);
        const eased = 1 - (1 - time) ** 3;

        window.scrollTo(0, start * (1 - eased));

        if (time < 1) {
            requestAnimationFrame(scroll);
        }
    }

    requestAnimationFrame(scroll);
}

export const usePersistedPage = (
    storageKey,
    itemsPerPage,
    totalItems,
    currentPage,
    onPageChange,
) => {
    const [pageCount, setPageCount] = useState(1);
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        if (storageKey && !isInitialized) {
            const savedPage = sessionStorage.getItem(storageKey);
            if (savedPage) {
                const pageNum = parseInt(savedPage, 10);
                if (!Number.isNaN(pageNum) && pageNum !== currentPage) {
                    onPageChange(pageNum);
                }
            }
            setIsInitialized(true);
        }
    }, [storageKey, isInitialized, currentPage, onPageChange]);

    useEffect(() => {
        const count = totalItems > 0 ? Math.ceil(totalItems / itemsPerPage) : 1;
        setPageCount(count);
    }, [totalItems, itemsPerPage]);

    useEffect(() => {
        if (currentPage >= pageCount && pageCount > 0 && isInitialized) {
            const newPage = Math.max(0, pageCount - 1);
            onPageChange(newPage);
            if (storageKey) {
                sessionStorage.setItem(storageKey, newPage.toString());
            }
        }
    }, [pageCount, currentPage, storageKey, onPageChange, isInitialized]);

    const handlePageClick = useCallback(
        (event) => {
            const newPage = event.selected;
            onPageChange(newPage);

            if (storageKey) {
                sessionStorage.setItem(storageKey, newPage.toString());
            }

            setTimeout(() => {
                smoothScrollToTop();
            }, 50);
        },
        [storageKey, onPageChange],
    );

    return { pageCount, handlePageClick };
};
